<div class="card rounded-2">
	<div class="card-body bg-gray-200 p-4">
		<ul class="nav nav-tabs nav-line-tabs nav-line-tabs-2x mb-5 fs-6">
			<li class="nav-item">
				<a class="nav-link active" data-bs-toggle="tab" href="#permissions_pane_1">Permissions</a>
			</li>
		</ul>
		<div class="tab-content" id="myTabContent">
			<div class="tab-pane fade show active" id="permissions_pane_1" role="tabpanel">
				<app-cm-permissions-list></app-cm-permissions-list>
			</div>
		</div>
	</div>
</div>

<app-common-add-permission-modal></app-common-add-permission-modal>
<app-common-update-permission-modal></app-common-update-permission-modal>

<script src="/assets/js/custom/apps/user-management/permissions/list.js"></script>
<script src="/assets/js/custom/apps/user-management/permissions/add-permission.js"></script>
<script src="/assets/js/custom/apps/user-management/permissions/update-permission.js"></script>